import { apiFields } from "./_utils";
import { getLinewizeFilterFeatureFlags } from "@/api/linewizeFilterFeatureFlags";
import useStore from ".";
import { getFeatures } from "./classwizeConfigStore";

export const createFeatureTogglesStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {
		"classwize-teacher-student-chat": false,
		"connection-search-report": false,
		"hide-courses-tab": false,
		"show-manage-user-password": false,
		"shr-enabled": false,
		global_rules_validation_enabled: false,
		rules_validation_enabled: false,
		"show-courses-tab": false,
		"show-classwize-training": false,
		"agent-p2p-screenshots": false,
	},

	fetch: async () => {
		setIn({ isFetching: true });
		const data = await getLinewizeFilterFeatureFlags();

		//Add local storage toggles
		Object.keys(localStorage).forEach((key) => {
			if (localStorage.getItem(key) === "true" || localStorage.getItem(key) === "false") {
				data[key] = localStorage.getItem(key) === "true";
			}
		});

		setIn({ data, isFetching: false, lastFetched: Date.now() });
	},

	isNativeAppControlsEnabled: () => getFeatures(useStore.getState()).includes("native_app_controls"),
});

/**
 * Get Linewize Filter Feature Flags
 */

export const getFeatureFlags = (state) => state.featureToggles.data;
